import { useParams } from 'react-router-dom';

import { ApiBaseUrlHint } from './ApiBaseUrlHint';
import { ApiTokensSection } from './ApiTokensSection';
import { ProjectRepositorySection } from './ProjectRepositorySection';

/**
 * Интеграции проекта: репозиторий для AI-аналитика, полный адрес API для
 * справки и токены публичного API (docs/12, docs/17 §5.5, UC-INT-01).
 * Страница живёт внутри ProjectLayout, который уже проверил права
 * администратора проекта.
 *
 * Репозиторий раньше настраивался у AI-агента; теперь это свойство проекта:
 * при подключении агент получает URL, ветку и read-only токен отсюда.
 *
 * Подписок на вебхуки здесь сознательно нет: UI раздела убран по требованию
 * заказчика. Подписки заводит внешняя автоматизация через
 * `POST /api/v1/webhooks` с токеном `webhooks:write` (docs/12 §9).
 */
export function IntegrationsSettingsPage() {
  const { key = '' } = useParams<{ key: string }>();

  return (
    <>
      <ProjectRepositorySection projectKey={key} />
      <ApiBaseUrlHint />
      <ApiTokensSection projectKey={key} />
    </>
  );
}
